// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport } from '@tectonics/prs/validation';

import { validateCustomerName } from './customer-name';
import { validateCustomerEmail } from './customer-email';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import {
  getCurrentPaymentMethodOptionalFields,
  hasOptionalField,
} from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import {validateCustomerBirthdate} from '@tectonics/prs/customer/validation/customer-birthdate';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  const optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];
  const isCriptocurrencyPaymentMethod = userInputValues['selectedPaymentMethod'] === 'cryptocurrency';

  switch (userInputName) {
    case 'customerName':
      if (!hasOptionalField(optionalFields, 'name')) {
        return onlyWhen('field_customer_name') && validateCustomerName(userInputValue);
      }
      return null;

    case 'customerEmail':
      return onlyWhen('field_customer_email') && validateCustomerEmail(userInputValue);

    case 'customerBirthdate':
      return isCriptocurrencyPaymentMethod ? validateCustomerBirthdate(userInputValue) : null;

    default:
      return undefined;
  }
}
